import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { requestCanceller } from '../../../service/axiosCancelToken';
import { productValidator } from '../../../service/validatorForms';
import LoadingSpinner from '../../shared/LoadingSpinner';
import DashboardContext from '../../context/dashboardContext';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';
import { getAllProductCategories } from '../../../service/productCategoryService';
import { createProduct } from '../../../service/productService';


const CreateProduct = () => {

    const [title, setTitle] = useState('');
    const [unit, setUnit] = useState('');
    const [minValue, setMinValue] = useState('');
    const [ourPrice, setOurPrice] = useState('');
    const [generalPrice, setGeneralPrice] = useState('');

    const [productCategories, setProductCategories] = useState([]);
    const [productCategoryName, setProductCategoryName] = useState();
    const [productCategoryId, setProductCategoryId] = useState();
    const [productInfo, setProductInfo] = useState('');
    const [telephone, setTelephone] = useState('');
    const [address, setAddress] = useState('');
    const [score, setScore] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSpinner, setLoadingSpinner] = useState(false);

    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);

    const validatorRef = useRef(productValidator());
    const {addToast} = useToasts();
    const history = useHistory();
    const dashContext = useContext(DashboardContext);
    
    
    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                const newProduct = {
                    title,
                    productCategoryId,
                    productCategoryName,
                    unit,
                    info: productInfo,
                    address,
                    telephone,
                    generalPrice,
                    ourPrice,
                    minValue,
                    score
                }
                
                setLoadingSpinner(true);

                const { status } = await createProduct(newProduct);
                if (status === 201) {
                    addToast("مکان جدید با موفقیت ساخته شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    dashContext.setProductCount(dashContext.productCount + 1);
                    setTitle("")
                    setGeneralPrice("");
                    setOurPrice("");
                    setMinValue("");
                    setProductCategoryName("");
                    setProductCategoryId("");
                    setUnit("");
                    setProductInfo("");
                    setTelephone("");
                    setAddress("");
                    setScore("");
                    setLoadingSpinner(false);

                    validatorRef.current.hideMessageFor("title");
                    validatorRef.current.hideMessageFor("productCategoryId");
                    validatorRef.current.hideMessageFor("productCategoryName");
                    validatorRef.current.hideMessageFor("productInfo");
                    validatorRef.current.hideMessageFor("address");
                    validatorRef.current.hideMessageFor("telephone");
                    validatorRef.current.hideMessageFor("telephone");
                    validatorRef.current.hideMessageFor("age");
                    validatorRef.current.hideMessageFor("score");
                    validatorRef.current.hideMessageFor("unit");
                    validatorRef.current.hideMessageFor("generalPrice");
                    validatorRef.current.hideMessageFor("ourPrice");
                    validatorRef.current.hideMessageFor("minValue");
                    validatorRef.current.hideMessages();
                    forceUpdate()
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("شماره موبایل و یا کد متخصص قبلا ثبت شده است", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 422) {
                addToast("اطلاعات را کامل وارد کنید", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if(err.response && err.response.status === 401){
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            setLoadingSpinner(false);
        }
    }

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchCategories = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllProductCategories({cancelToken: cancelRequest.signal});
                if(status === 201){
                    setProductCategories(data.productCategories);
                }
            
                setIsLoading(false);
            } catch (err) {}
        } 
        fetchCategories();
        return () => {
			cancelRequest.cancel();
        }
    },[]);


    const setPlaceCategoryHandler = (event) => {
        try {
            productCategories.forEach(category => {
                if(String(category._id) === String(productCategories[event.target.selectedIndex - 1]._id)){
                    setProductCategoryName(category.title);
                    setProductCategoryId(category._id)
                }
            })
        } catch (error) {}
    }


    return ( 
        <React.Fragment>
        {
            isLoading ? 
            <div style={{ height: '70vh' }} className="d-flex">
                <div className="text-center align-self-center mx-auto">
                    <LoadingSpinner />
                </div>
            </div>
            :
            <div className="new-place-container">
                <header >
                    <h1>ایجاد کالا</h1>
                </header>
                <section>
                    <form onSubmit={submitHandler}>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label htmlFor="title323">
                                عنوان
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="title323"
                                    placeholder="عنوان"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    onBlur={() => {
                                        if (title !== '') {
                                            validatorRef.current.showMessageFor("title");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "title",
                                    title,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6">
                                <label htmlFor="telephone">تلفن محل ارسال</label>
                                <input
                                    type="text"
                                    className="form-control ltr pr-3"
                                    style={{fontFamily: 'FontAwesome'}}
                                    id="telephone"
                                    placeholder= '&#xf095;  09... 0513...'
                                    value={telephone}
                                    onChange={(e) => setTelephone(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (telephone !== '') {
                                            validatorRef.current.showMessageFor("telephone");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "telephone",
                                    telephone,
                                    "required|phone"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                
                            <label htmlFor="unit323">
                                واحد اندازه گیری
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="unit323"
                                    placeholder="واحد اندازه گیری"
                                    value={unit}
                                    onChange={(e) => setUnit(e.target.value)}
                                    onBlur={() => {
                                        if (unit !== '') {
                                            validatorRef.current.showMessageFor("unit");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "unit",
                                    unit,
                                    "required"
                                )}
                            
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="inputState1">دسته بندی</label>
                                <select id="inputState1" className="form-control "
                                    onChange={setPlaceCategoryHandler}
                                >
                                    <option  hidden>{productCategoryName ? productCategoryName : 'انتخاب کنید ...'}</option>
                                    {
                                        productCategories.map((item) => (
                                            <option key={item._id}>
                                                {item.title}
                                            </option>
                                        ))
                                    }
                                </select>
                                {validatorRef.current.message(
                                    "productCategoryName",
                                    productCategoryName,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time81"> نمره (بین 0 تا 5 )</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time81"
                                    placeholder="نمره"
                                    value={score}
                                    onChange={(e) => setScore(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (score !== '') {
                                            validatorRef.current.showMessageFor("score");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "score",
                                    score,
                                    "required|numeric"
                                )}
                            </div>
                        </div>
                        <section >
                            <div className="d-flex flex-wrap justify-content-between">
                                <div className="form-group col-sm-6 align-self-center px-0">
                                    <label htmlFor="exampleFormControlTextarea5">
                                        توضیحات درباره محصول
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea5"
                                        rows="4"
                                        placeholder="در حد چند کلمه توضیح دهید"
                                        value={productInfo}
                                        name="productInfo"
                                        aria-describedby="description"
                                        onChange={ e => setProductInfo(e.target.value)}
                                        onBlur={() => {
                                            if (productInfo !== '') {
                                                validatorRef.current.showMessageFor("productInfo");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "productInfo",
                                        productInfo,
                                        "required|min:5"
                                    )}
                                </div>
                                <div className="form-group col-sm-6 align-self-center">
                                    <label htmlFor="exampleFormControlTextarea6">
                                        آدرس
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea6"
                                        rows="4"
                                        placeholder="آدرس"
                                        value={address}
                                        name="address"
                                        aria-describedby="description"
                                        onChange={ e => setAddress(e.target.value)}
                                        onBlur={() => {
                                            if (address !== '') {
                                                validatorRef.current.showMessageFor("address");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "address",
                                        address,
                                        "required|min:5"
                                    )}
                                </div>
                            </div>
                        </section>
                        <div className="form-row">
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="minvalue81">حداقل مقدار برای خرید</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="minvalue81"
                                    placeholder="حداقل میزان خرید"
                                    value={minValue}
                                    onChange={(e) => setMinValue(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (minValue !== '') {
                                            validatorRef.current.showMessageFor("minValue");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "minValue",
                                    minValue,
                                    "required|numeric"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="ourPrice81">قیمت واحد ما</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="ourPrice81"
                                    placeholder="قیمت واحد ما"
                                    value={ourPrice}
                                    onChange={(e) => setOurPrice(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (ourPrice !== '') {
                                            validatorRef.current.showMessageFor("ourPrice");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "ourPrice",
                                    ourPrice,
                                    "required|numeric"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="generalPrice81">قیمت واحد بازار</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="generalPrice81"
                                    placeholder="قیمت واحد بازار"
                                    value={generalPrice}
                                    onChange={(e) => setGeneralPrice(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (generalPrice !== '') {
                                            validatorRef.current.showMessageFor("generalPrice");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "generalPrice",
                                    generalPrice,
                                    "required|numeric"
                                )}
                            </div>
                        </div>
                        <div className="text-center mt-4">
                        <button 
                                type="submit"
                                className="btn btn-success mr-1 "
                                style={{ width: "100px" }}
                                disabled={loadingSpinner}
                            >
                                <i 
                                    className={loadingSpinner ? 'spinner-border spinner-border-sm mr-2': ''} 
                                    style={{position:'relative', bottom:'2px'}}
                                ></i>
                                ثبت
                                
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger "
                                style={{ width: "100px" }}
                                onClick={() => history.replace('/dashboard/products')}
                            >
                                بازگشت
                            </button>
                        </div>
                    </form>
                </section>
            </div>
        }
        </React.Fragment>
     );
}
 
export default CreateProduct;